"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("src/utilities/styled/color"));
exports.default = (function (_a) {
    var theme = _a.theme, background = _a.background;
    var value = (0, color_1.default)({ theme: theme, color: background });
    return value && "background-color: " + value + ";";
});
